import {useEffect} from "react";
import {BrowserRouter as Router, Switch} from 'react-router-dom';
import AOS from "aos";
import NavScrollTop from './components/NavScrollTop';


import routerMap from "./routerMap";
import FrontendAuth from "./FrontendAuth";

// import HomeOne from './pages/HomeOne';
// import Contact from './pages/Contact';

// // add new pages for icis 2022

// import Topic from './pages/Topic';
// import Competition from './pages/Competition';
// import Submission from './pages/Submission';
// import Deadlines from './pages/Deadlines';
// import SpecialSession from './pages/SpecialSession';
// import Registration from './pages/Registration';
// import Venue from './pages/Venue';
// import Transportation from './pages/Transportation';
// import Accommodation from './pages/Accommodation';
// import Scenery from './pages/Scenery';
// import ReceptionBanquet from './pages/ReceptionBanquet';
// import Visa from './pages/Visa';
// import Program from './pages/Program';
// import Speakers from './pages/Speakers';
// import Tutorials from './pages/Tutorials';
// import Symposia from './pages/Symposia';
// import Committees from './pages/Committees';
// import Sponsors from './pages/Sponsors';
// import History from './pages/History';
// import Pay from './pages/Pay';
// import Paych from './pages/Paych';
// import Form from './pages/Form';
// import Upload from './pages/Upload';
// import Verify from './pages/Verify';

// // add Chinese pages
// import Submission_zn from './pages/Submission_zn';
// import Competition_zn from './pages/Competition_zn';
// import Venue_zn from './pages/Venue_zn';
// import Transportation_zn from './pages/Transportation_zn';
// import Accommodation_zn from './pages/Accommodation_zn';
// import Scenery_zn from './pages/Scenery_zn';
// import ReceptionBanquet_zn from './pages/ReceptionBanquet_zn';




// CSS File Here
import "aos/dist/aos.css";
import 'react-modal-video/scss/modal-video.scss';
import './assets/scss/style.scss';


function App() {
  useEffect(() => {
    AOS.init({
        offset: 80,
        duration: 1000,
        once: true,
        easing: 'ease',
    });
    AOS.refresh();
    
  }, [])
  return (
      <Router>
        <NavScrollTop>
            <Switch>
            <FrontendAuth routerConfig={routerMap} />
            </Switch>
          </NavScrollTop>
      </Router>
  );
}

export default App;
